import { Column, ColumnState } from '@ag-grid-community/core';
import { ZeroGridPro } from '@genesislcap/foundation-zero-grid-pro';

export const LOCAL_STORAGE_GRID_KEY = 'gridOptions';

export class GridDelegate {
  constructor(private grid: ZeroGridPro, private stateKey: string) {}

  /**
   * Used for changing the state key of a single grid to another state key. Optionally will retain any added
   * columns or removed columns. Will not keep the old widths.
   * @param stateKey The new state key
   * @param retainColumns whether to keep old columns, sorting, order, etc. (excludes column width)
   */
  public changeState(stateKey: string, retainColumns: boolean = true) {
    this.stateKey = stateKey;
    if (retainColumns) {
      try {
        const oldColDef: ColumnState[] = this.grid.columnApi.getColumnState();
        const oldVisible = this.grid.columnApi?.getAllDisplayedColumns();
        this.reloadColumnState().then(() => {
          const currentVisible = this.grid.columnApi?.getAllDisplayedColumns();
          const columnsToRemove = this.checkColumnArrayDiff(currentVisible, oldVisible);
          const columnsToAdd = this.checkColumnArrayDiff(oldVisible, currentVisible);
          this.grid.columnApi.setColumnsVisible(columnsToAdd, true);
          this.grid.columnApi.setColumnsVisible(columnsToRemove, false);
          const currentColDefs: ColumnState[] = this.grid.columnApi.getColumnState();
          const adjustedColumnDefs = oldColDef.map((c: ColumnState) => {
            c.width = currentColDefs.find(
              (currentColumn: ColumnState) => currentColumn.colId === c.colId
            ).width;
            return c;
          });
          this.grid.columnApi.applyColumnState({
            state: adjustedColumnDefs,
          });

          //Saves current column state
          this.grid.gridApi.dispatchEvent({
            type: 'columnResized',
          });
        });
      } catch (e) {
        console.debug('Grid is not available yet');
      }
    } else this.reloadColumnState();
  }

  private checkColumnArrayDiff(current: Column[], old: Column[]): Column[] {
    const oldNames = old.map((column) => column.getColId());
    return current.filter((column) => !oldNames.includes(column.getColId()));
  }

  public async reloadColumnState() {
    if (!this.grid.gridApi) {
      return;
    }
    if (localStorage.getItem(LOCAL_STORAGE_GRID_KEY)) {
      const gridOptions = JSON.parse(localStorage.getItem(LOCAL_STORAGE_GRID_KEY));
      if (gridOptions && this.stateKey in gridOptions) {
        const savedState = gridOptions[this.stateKey];
        const currentState = JSON.stringify(this.grid.columnApi.getColumnState());
        if (savedState != currentState) {
          this.grid['suppressColumnMoveAnimation'] = true;
          this.grid.columnApi.applyColumnState({
            state: JSON.parse(savedState),
            applyOrder: true,
          });
          this.grid['suppressColumnMoveAnimation'] = false;
        }
      }
    }
  }
}
